import { ExternalUserGrantAssignmentDto } from "../../dtos/ExternalUserGrantAssignmentDto";
import { GrantOptionDto } from "../../dtos/GrantOptionDto";
import { UserDto } from "../../dtos/UserDto";
import { ApiResult, apiWrapper, apiWrapperWithError } from "./ApiUtils";

export const getUsers = async (): Promise<ApiResult<UserDto[]> | null> => {
    return apiWrapperWithError<UserDto[]>('api/v2/users', 'GET', 'fetching users');
}

export const createUser = async (user: UserDto): Promise<ApiResult<UserDto> | null> => {
    return apiWrapperWithError<UserDto>('api/v2/users', 'POST', 'creating user', user);
}

export const updateUser = async (id: string, user: UserDto): Promise<ApiResult<UserDto> | null> => {
    return apiWrapperWithError<UserDto>(`api/v2/users/${id}`, 'PUT', 'updating user', user);
}

export const usernameExists = async (username: string, excludeId?: string): Promise<boolean | null> => {
    const query = excludeId ? `?excludeId=${excludeId}` : '';
    return apiWrapper<boolean>(`api/v2/users/username-exists/${encodeURIComponent(username)}${query}`, 'GET', 'checking username');
}

export const emailExists = async (email: string, excludeId?: string): Promise<boolean | null> => {
    const query = excludeId ? `?excludeId=${excludeId}` : '';
    return apiWrapper<boolean>(`api/v2/users/email-exists/${encodeURIComponent(email)}${query}`, 'GET', 'checking email');
}

export const getGrantOptions = async (): Promise<ApiResult<GrantOptionDto[]> | null> => {
    return apiWrapperWithError<GrantOptionDto[]>('api/v2/users/grant-options', 'GET', 'fetching grant options');
}

export const getUserGrantAssignments = async (userId: string): Promise<ApiResult<ExternalUserGrantAssignmentDto[]> | null> => {
    return apiWrapperWithError<ExternalUserGrantAssignmentDto[]>(`api/v2/users/${userId}/grant-assignments`, 'GET', 'fetching grant assignments');
}

export const createExternalUser = async (user: UserDto): Promise<ApiResult<UserDto> | null> => {
    return apiWrapperWithError<UserDto>('api/v2/users/external', 'POST', 'creating external user', user);
}

export const updateExternalUser = async (id: string, user: UserDto): Promise<ApiResult<UserDto> | null> => {
    return apiWrapperWithError<UserDto>(`api/v2/users/external/${id}`, 'PUT', 'updating external user', user);
}
